// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BottomMark_wrapper__TxXo1 {\n  background: #f5f5f5;\n  border-radius: 0px 0px 2px 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 9px 33px;\n  min-height: 33px; }\n  .BottomMark_wrapper__TxXo1 > span {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #1890ff;\n    cursor: pointer; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "BottomMark_wrapper__TxXo1"
};
module.exports = exports;
